<template>
  <div class="footer">
    <b-container fluid class="h-100">
      <b-row class="h-100 text-center mt-2" align-v="center">
        <b-col cols="12" lg="5" class="d-flex">
          <b-form
            v-if="!submitComplete"
            @submit="onSubmit"
            inline
            class="mx-auto mx-lg-0"
          >
            <label class="sr-only" for="input-1">{{
              $t("common.enteremail")
            }}</label>
            <b-input
              id="input-1"
              class="mb-2 mr-sm-2 mb-sm-0 mx-lg-1"
              :placeholder="$t('common.enteremail')"
              required
              v-model="form.email"
              type="email"
              style="width: 300px"
            ></b-input>
            <button
              class="btn btn-outline-secondary tbsq mx-lg-0"
              type="submit"
              id="button-addon2"
            >
              {{ $t("main-screen.sign-up.title") }}
            </button>
          </b-form>
          <div v-else>
            <b-spinner label="Spinning" v-if="submitting"></b-spinner>
            <p v-else>{{ $t("common.newsletter_thank") }}</p>
          </div>
        </b-col>
        <b-col lg="2" class="mt-3 mt-md-1 align-items-center">
          <p style="font-weight: 300; color: lightgrey">
            1989 - 2023 Beaute Integrale
          </p>
        </b-col>
        <b-col lg="5" class="my-1 text-lg-right">
          <b-button
            variant="outline-dark"
            class="border-0"
            to="/terms-privacy"
            >{{ $t("main-screen.terms.title") }}</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "tfooter",
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA",
      submitComplete: false,
      submitting: false,
      form: {
        language_code: this.$i18n.locale,
        email: "",
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      // let data = (JSON.stringify(this.form))
      let data = Object.assign({}, this.form);
      this.submitting = true;
      axios
        .post("https://api.beauteintegrale.ca/submissions/newsletters", data)
        .then((resp) => {
          this.submitting = false;
          this.submitComplete = true;
          this.form.email = "";
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.footer {
  min-height: 60px;
}
p {
  margin: auto !important;
  color: black;
}
.tbsq {
  border-radius: 0;
}
@media only screen and (max-width: 600px) {
  .footer {
    padding: 25px;
    min-height: 2vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue